import React from "react";

import LogoImage from "../../assets/images/logo.jpeg";

const Logo = (props) => {
  return <img width={"100px"} {...props} src={LogoImage} alt="Logo" />;
};

export default Logo;
